// extracted by mini-css-extract-plugin
export default {"container":"TrashMarker_container__6iodM","img":"TrashMarker_img__HC709"};